import {QueryClient, useQuery} from 'react-query';

import { LATEST_NEWS } from "./keys"
import { NewsService } from "../types"

export function useGetLatestNews() {
    return useQuery(LATEST_NEWS, NewsService.getLastNews);
}


export async function prefetchLatestNews(queryClient: QueryClient){ 
    return await queryClient.prefetchQuery({ queryKey: [LATEST_NEWS], queryFn: NewsService.getLastNews })
}